export default {
  background: '#FFFFFF', // White
  black: '#000000', // Black
  subtitle: '#f8f9fa', // Grayish
  draksubtitle: '#77838f', // Dark Grayish
  button: '#3498db', // Summer Sky
  line: '#dae0e5', // Pattens Blue
  success: '#e5f9f6', // Light Cyan
  successtext: '#00c9a7', // Caribbean Green
  fail: '#fceceb', // Tutu
  failtext: '#de4437', // Cinnabar
  etherbackgroundcolor: '#f1f2f4', // Solitude
  etherinfo: '#e7eaf3', // Solitude
  ethershadow: '#EDEEF0', // Solitude
  scrollthumb: '#D5D5D7', // Ghost
  attribute: '#f8fafd', // Alice Blue
  searchboxleft: '#1e83e5', // Dodger Blue
  searchboxright: '#273ea7', // Persian Blue
  dropdownborder: '#CCCCCC', // Very Light Grey
  doprdowncolor: '#333333', // Night Rider
  headertext: '#6c757e', // Raven
};

// ${props => props.theme.subtitle} // 메인
// ${props => props.theme.background}
// ${props => props.theme.draksubtitle} //subtitle contenttitle navigationtext
// ${props => props.theme.button}
// ${props => props.theme.etherbackgroundcolor}
// ${props => props.theme.etherinfo}
// ${props => props.theme.ethershadow} // 그림자
// ${props => props.theme.black}
// ${props => props.theme.scrollthumb} // 휠
// ${props => lighten(0.42, props.theme.button)} //배경
// ${props => darken(0.1, props.theme.button)}; // 텍스트
// ${props => props.theme.attribute} //표 헤더
